import 'isotope-layout/dist/isotope.pkgd.min';
// store filter per group
const filters = {};

function getComboFilter() {
  let combo = [];
  Object.values(filters).forEach((prop) => {
    const group = prop;
    if (group.length) {
      // add first group
      if (combo.length) {
        // add additional groups
        const nextCombo = [];
        // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
        for (let i = 0; i < combo.length; i += 1) {
          for (let j = 0; j < group.length; j += 1) {
            const item = combo[i] + group[j];
            nextCombo.push(item);
          }
        }
        combo = nextCombo;
      } else {
        combo = group.slice(0);
      }
    }
  });
  const comboFilter = combo.join(', ');
  return comboFilter;
}

function init() {
  const $joblist = $('.job-list').isotope({
    itemSelector: '.job',
    layoutMode: 'vertical',
    hiddenStyle: {
      opacity: 0,
    },
    visibleStyle: {
      opacity: 1,
    },
  });

  $('#job-filters').on('change', (event) => {
    const checkbox = event.target;
    const $checkbox = $(checkbox);
    const group = $checkbox.parents('.option-set').attr('data-group');
    // create array for filter group, if not there yet
    let filterGroup = filters[group];
    if (!filterGroup) {
      filters[group] = [];
      filterGroup = filters[group];
    }
    // add/remove filter
    if (checkbox.checked) {
      // add filter
      filterGroup.push(checkbox.value);
    } else {
      // remove filter
      const index = filterGroup.indexOf(checkbox.value);
      filterGroup.splice(index, 1);
    }

    $('.isotope-no-result').fadeOut('fast');
    $joblist.isotope({ filter: getComboFilter() });
  });

  // eslint-disable-next-line
  $joblist.on('arrangeComplete', (event, filteredItems) => {
    if (filteredItems.length === 0) {
      $('.isotope-no-result').fadeIn('slow');
    }
  });
  $('.check-all').on('click', (event) => {
    event.preventDefault();
    $(event.target)
      .parents('.option-set')
      .find('input[type="checkbox"]')
      .prop('checked', true)
      .trigger('change');
    $('.isotope-no-result').fadeOut('fast');
    $joblist.isotope({ filter: getComboFilter() });
  });

  $('.uncheck-all').on('click', (event) => {
    event.preventDefault();
    $(event.target)
      .parents('.option-set')
      .find('input[type="checkbox"]')
      .prop('checked', false)
      .trigger('change');
    $('.isotope-no-result').fadeOut('fast');
    $joblist.isotope({ filter: getComboFilter() });
  });
}

export default init;
